import { c as _c } from "react/compiler-runtime";
import { cn } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';
import { useChatOverlayContext } from '../contexts/chat-overlay-context';
interface ChatContainerProps {
  children: ReactNode;
  className?: string;
  isVisible?: boolean;
}

/**
 * Container wrapper component that handles the main chat container styling and layout.
 * Uses context to determine fullscreen and sidebar state for conditional styling.
 * When isVisible is false, the container is hidden but remains mounted to preserve state.
 */
export function ChatContainer(t0) {
  const $ = _c(12);
  const {
    children,
    className,
    isVisible: t1
  } = t0;
  const isVisible = t1 === undefined ? true : t1;
  const {
    isSidebarOpen,
    isFullscreen
  } = useChatOverlayContext();
  const t2 = !isFullscreen;
  let t3;
  if ($[0] !== className || $[1] !== isFullscreen || $[2] !== isSidebarOpen || $[3] !== t2) {
    t3 = cn("fixed right-9 bottom-0 z-[1000]", "border-border/50 rounded-t-sm border", "bg-background", "shadow-floating-bar", "flex flex-row", {
      "inset-0 rounded-none": isFullscreen,
      "h-[50dvh] min-h-[650px] w-[800px] min-w-[600px]": t2,
      "rounded-tl-none": isSidebarOpen
    }, className);
    $[0] = className;
    $[1] = isFullscreen;
    $[2] = isSidebarOpen;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isVisible ? "auto" : "none";
  const t5 = isVisible ? "visible" : "hidden";
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = {
      pointerEvents: t4,
      visibility: t5
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children || $[9] !== t3 || $[10] !== t6) {
    t7 = <div className={t3} style={t6}>{children}</div>;
    $[8] = children;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}